/* FemmeMod motion: progressive enhancement. If this never runs, nothing is hidden. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn) { if (d.readyState !== 'loading') { fn(); } else { d.addEventListener('DOMContentLoaded', fn); } }
  ready(function () {
    var heroImg = d.querySelector('.fm-hero__img');
    var about = d.querySelector('.about');
    var aboutStage = about ? about.querySelector('.about__stage') : null;
    var ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      if (about && aboutStage && !reduce) {
        var r = about.getBoundingClientRect();
        var top = parseFloat(window.getComputedStyle(aboutStage).top) || 0;
        var total = r.height - aboutStage.offsetHeight;
        var p = total > 0 ? (top - r.top) / total : 0;
        about.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
      }
      if (heroImg && !reduce && y < 1400) { heroImg.style.setProperty('--py', Math.min(y * 0.05, 36) + 'px'); }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (reduce || !('IntersectionObserver' in window)) { return; }
    var groups = ['.fm-shead', '.fm-glance__item', '.fm-tile', '.fm-products > li', '.fm-members-teaser', '.fm-empty', '.fm-confidence__lead > *', '.fm-confidence__list li', '.product-grid > li', '.footer-block'];
    var els = [];
    groups.forEach(function (sel) {
      var last = null, i = 0;
      d.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('.fm-hero__copy') || el.classList.contains('reveal')) { return; }
        if (el.parentNode !== last) { last = el.parentNode; i = 0; }
        el.classList.add('reveal');
        el.style.setProperty('--d', Math.min(i * 0.08, 0.4) + 's');
        i++; els.push(el);
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    var vh = window.innerHeight || 800;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > 0) { el.classList.add('in'); } else { io.observe(el); }
    });
    root.classList.add('fm-motion');
  });
})();
